module.exports = __webpack_public_path__ + "media/school.472b7cf7.png";